import FormattedMessage from 'I18n/components/FormattedMessage';
import { ChatWidgetLocaleContextConsumer } from 'conversations-visitor-experience-components/visitor-widget/ChatWidgetLocaleContext';
import styled, { css } from 'styled-components';
import { DEFAULT_HELP_TEXT_COLOR } from 'visitor-ui-component-library/theme/ColorConstants';
import { adjustLuminance } from 'visitor-ui-component-library/utils/adjustLuminance';
import { getFocusRingStyles } from 'visitor-ui-component-library/utils/getFocusRingStyles';
import { getHideNewThreadLink } from '../../query-params/getHideNewThreadLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NewThreadpromptContainer = styled.div.withConfig({
  displayName: "NewThreadPrompt__NewThreadpromptContainer"
})(["padding:32px 20px 12px 20px;text-align:center;width:100%;"]);
const StartNewChatButton = styled.button.withConfig({
  displayName: "NewThreadPrompt__StartNewChatButton"
})(({
  $textColor
}) => css(["background:none;border:none;color:", ";cursor:pointer;font:inherit;transition:color 0.15s ease;&:hover{color:", ";}border-radius:2px;", ""], $textColor, adjustLuminance($textColor, 20), getFocusRingStyles({
  outlineOffset: '2px'
})));
function NewThreadPrompt({
  accentColor,
  createNewThread,
  useDefaultColor
}) {
  const textColor = useDefaultColor ? DEFAULT_HELP_TEXT_COLOR : accentColor;
  const hideNewThreadLink = getHideNewThreadLink();
  return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
    children: locale => /*#__PURE__*/_jsxs(NewThreadpromptContainer, {
      role: "status",
      children: [/*#__PURE__*/_jsx("p", {
        className: "m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.newThreadPrompt.newHeading",
          options: {
            locale
          }
        })
      }), !hideNewThreadLink && /*#__PURE__*/_jsx(StartNewChatButton, {
        onClick: createNewThread,
        $textColor: textColor,
        "data-test-id": "visitor-widget-start-new-thread-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.newThreadPrompt.newButton",
          options: {
            locale
          }
        })
      })]
    })
  });
}
NewThreadPrompt.displayName = 'NewThreadPrompt';
export default NewThreadPrompt;